module.exports = __webpack_public_path__ + "static/img/greenadvise.b0e36df.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xinyuan/greenadvise.png
// module id = FgzQ
// module chunks = 0